import { StatusBar } from 'expo-status-bar';
import React,{useEffect,useState}  from 'react';
import { StyleSheet, Text, View, Image, TextInput,TouchableOpacity, Alert} from 'react-native';
import ButtonGradient from '../modules/component/ButtonGradient';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import * as Location from 'expo-location';
import { apiFetch } from '../modules/api';


  const RegistroCoordenadas = () => {
    
    const navigation = useNavigation();
    const [contrasena,setContrasena] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);
    
    const limpiarFormulario = () => {

      setContrasena('')

    }
   
    const showAlert = () => 
   
    Alert.alert(gMsg, 'Oprima Aceptar para continuar', [
      { text: "Aceptar" }
      ],
      { cancelable: true });


    async function guardarCoordenadas(){

      let location = await Location.getCurrentPositionAsync({
        accuracy: Location.Accuracy.High,
        timeInterval: 5000,
        distanceInterval: 100
      });
        let geoloc = 'Waiting..';
        if (errorMsg) {
            geoloc = errorMsg;
        } else if (location) {
            geoloc = location.coords
        }

    var altitude = geoloc.altitude
    var latitude = geoloc.latitude
    var longitude = geoloc.longitude

      var datos = '{"contrasena" : "' + contrasena + '","operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '","latitude" : "' + latitude + '","longitude" : "' + longitude + '","altitude" : "' + altitude  + '"}' 
      


      var requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: datos
      };
      
        const response = await apiFetch(gApiPath + "/api/guardarCoordenadas",requestOptions);
        const json = await response.json();


        
        if (json.estatus == "bien"){

          datos = json.datos
          
          limpiarFormulario();
     
          gMsg = "Las Coordenadas se grabaron de manera correcta"; 
     
          navigation.goBack();
    
        }else{

          gMsg = json.mensaje; 
          limpiarFormulario();
          showAlert();
     
        }
    
    }
 

    
    return(
  
    <View style={styles.container}>
        <Fondo/>
        <Text style={styles.subTitle}>Registro</Text>
        <Text style={styles.subTitle}>Coordenadas</Text>
        <Text style={styles.subTitle}>de la tienda</Text>
        
    
        <Text style={styles.textLabels} >Contraseña</Text>
        <TextInput secureTextEntry={true} style={styles.textInput}
          value={contrasena}  
          onChangeText = {(value) => setContrasena(value)}
        />
       
        
        <TouchableOpacity  style={styles.container2} onPress={()=>guardarCoordenadas()}>

          <ButtonGradient texto="Registrar Coordenadas" />
        </TouchableOpacity>
        <StatusBar style="auto" />

        

      </View>
    
    );
  }

export default RegistroCoordenadas



const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f1f1f1',
    alignItems: 'center',
    justifyContent: 'center'

  },

  subTitle:{
    fontSize: 35,
    color: 'black',
    fontWeight: 'bold',

  },
  textLabels:{

    padding: 5,
    width: '80%',
    paddingTop: 20,
    fontWeight: 'bold',
    color: '#000',
    fontSize: 20
  },
  textInput:{

    padding: 5,
    width: '80%',
    height: 40,
    marginTop: 5,
    borderRadius: 30,
    fontWeight: 'bold',
    backgroundColor: '#f1f1f1',
    fontSize: 20
  },
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: 1000,
  },
  
    subTitle2:{
    fontSize: 15,
    color: 'gray',
    marginTop: 5,
    fontWeight: 'bold'

  },
  container2:{
      
    alignItems: 'center',
    justifyContent : 'center',
    marginTop:20,
    width: '80%',
    height: 70,


}

  
});


